"use strict";

function _interopRequireDefault(o) {
  return o && o.__esModule ? o : {
    default: o
  };
}
function _objectWithoutProperties(o, e) {
  var r = {};
  for (var t in o) e.indexOf(t) >= 0 || Object.prototype.hasOwnProperty.call(o, t) && (r[t] = o[t]);
  return r;
}
function make(o, e) {
  var r = e.left,
    t = e.right,
    p = e.up,
    n = e.down,
    a = e.top,
    i = e.bottom,
    l = e.mirror,
    u = e.opposite,
    s = (r ? 1 : 0) | (t ? 2 : 0) | (a || n ? 4 : 0) | (i || p ? 8 : 0) | (l ? 16 : 0) | (u ? 32 : 0) | (o ? 64 : 0);
  if (lookup.hasOwnProperty(s)) return lookup[s];
  if (!l != !(o && u)) {
    var d = [t, r, i, a, n, p];
    r = d[0], t = d[1], a = d[2], i = d[3], p = d[4], n = d[5];
  }
  var f = r || t,
    c = a || i || p || n,
    m = f || c,
    y = void 0,
    b = void 0,
    _ = void 0,
    v = void 0,
    T = void 0;
  return m ? o ? (b = f ? (r ? "" : "-") + "42px" : "0", _ = c ? (n || a ? "-" : "") + "60px" : "0", v = f ? (t ? "" : "-") + "2000px" : "0", T = c ? (p || i ? "" : "-") + "2000px" : "0", y = "40% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d(" + b + ", " + _ + ", 0);\n        }\n        to {\n          opacity: 0;\n          transform: scale(.1) translate3d(" + v + ", " + T + ", 0);\n          transform-origin: " + (c ? "center bottom" : (r ? "left" : "right") + " center") + ";\n        }") : (b = f ? (r ? "-" : "") + "1000px" : "0", _ = c ? (n || a ? "-" : "") + "1000px" : "0", v = f ? (t ? "-" : "") + "10px" : "0", T = c ? (p || i ? "-" : "") + "60px" : "0", y = "from {\n          opacity: 0;\n          transform: scale3d(.1, .1, .1) translate3d(" + b + ", " + _ + ", 0);\n          animation-timing-function: cubic-bezier(0.550, 0.055, 0.675, 0.190);\n        }\n        60% {\n          opacity: 1;\n          transform: scale3d(.475, .475, .475) translate3d(" + v + ", " + T + ", 0);\n          animation-timing-function: cubic-bezier(0.175, 0.885, 0.320, 1);\n        }") : y = (o ? "to" : "from") + " {opacity: 0; transform: scale3d(.1, .1, .1);} " + (o ? "from" : "to") + " { opacity: 1; transform: none;}", lookup[s] = (0, _globals.animation)(y), lookup[s];
}
function Zoom() {
  var o = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : _globals.defaults,
    e = o.children,
    r = (o.out, o.forever),
    t = o.timeout,
    p = o.duration,
    n = void 0 === p ? _globals.defaults.duration : p,
    a = o.delay,
    i = void 0 === a ? _globals.defaults.delay : a,
    l = o.count,
    u = void 0 === l ? _globals.defaults.count : l,
    s = _objectWithoutProperties(o, ["children", "out", "forever", "timeout", "duration", "delay", "count"]),
    d = {
      make: make,
      duration: void 0 === t ? n : t,
      delay: i,
      forever: r,
      count: u,
      style: {
        animationFillMode: "both"
      },
      reverse: s.left
    };
  return (0, _wrap2.default)(s, d, d, e);
}
Object.defineProperty(exports, "__esModule", {
  value: !0
});
var _propTypes = require("prop-types"),
  _wrap = require("./wrap"),
  _wrap2 = _interopRequireDefault(_wrap),
  _globals = require("./globals"),
  propTypes = {
    out: _propTypes.bool,
    left: _propTypes.bool,
    right: _propTypes.bool,
    top: _propTypes.bool,
    bottom: _propTypes.bool,
    mirror: _propTypes.bool,
    opposite: _propTypes.bool,
    duration: _propTypes.number,
    timeout: _propTypes.number,
    delay: _propTypes.number,
    count: _propTypes.number,
    forever: _propTypes.bool
  },
  lookup = {};
Zoom.propTypes = propTypes, exports.default = Zoom, module.exports = exports.default;